import React, { Component } from 'react';

const UniqueReasons = () => {
    let EventTypes = [
        {
            name: "icon-pumpkin",
            title: "Halloween Feest",
            hideOnMobile: true
        },{
            name: "icon-christmas-tree",
            title: "De jaarlijkse Kerstborrel",
            hideOnMobile: false
        },
        {
            name: "icon-fireworks2",
            title: "Oud & Nieuw",
            hideOnMobile: true
        },{
            name: "icon-party-hat",
            title: "Verjaardagen",
            hideOnMobile: false
        },{
            name: "icon-clown",
            title: "Kinderfeestjes",
            hideOnMobile: false
        },{
            name: "icon-couple",
            title: "Trouwerijen",
            hideOnMobile: false
        },{
            name: "icon-toast",
            title: "Huwelijksjubilea",
            hideOnMobile: false
        },{
            name: "icon-mask",
            title: "Gekostumeerd bal",
            hideOnMobile: true
        },{
            name: "icon-diadem",
            title: "Koningsdag",
            hideOnMobile: true
        },{
            name: "icon-easter-bunny",
            title: "Themadag in het winkelcentrum",
            hideOnMobile: true
        },{
            name: "icon-cradle",
            title: "Babyshower",
            hideOnMobile: false
        },{
            name: "icon-chimney",
            title: "Sinterklaas",
            hideOnMobile: true
        },{
            name: "icon-mirror-ball",
            title: "Schoolfeest",
            hideOnMobile: false
        },{
            name: "icon-backpack",
            title: "Examenfeest",
            hideOnMobile: true
        },{
            name: "icon-trophy",
            title: "Kampioensfeest",
            hideOnMobile: false
        },{
            name: "icon-real-estate-4",
            title: "Housewarming",
            hideOnMobile: true
        }
    ];

    function renderEvents(){
        return EventTypes.map((item) => {
            return (
                <div key={item.name} className={`column grow is-half-mobile fading-background ${item.hideOnMobile ? 'is-hidden-mobile' : ''}`}>
                    <a>
                        <div className="icon-primary icon-large">
                            <i className={item.name} />
                        </div>
                        <p>
                            <strong>{item.title}</strong>
                        </p>
                    </a>
                </div>
            )
        })
    }

    return (
        <div className="section">
            <div className="container">
                <div className="columns">
                    {/*<div className="column is-one-third has-text-centered">*/}
                        {/*<img src="http://www.photobooth.lu/wp-content/uploads/2015/02/LePhotobooth_cheese1.png" alt="Photobooth Placeholder"/>*/}
                    {/*</div>*/}
                    <div className="column has-text-centered content">
                        <div className="content has-text-centered">
                            <h2 className="title">Benieuwd waar de Photobooth het bijzonder goed doet?</h2>
                        </div>
                        <div className="columns is-multiline is-mobile">
                            { renderEvents() }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default UniqueReasons;


// WEBPACK FOOTER //
// ./src/components/uniqueReasons/index.js